export default "__VITE_ASSET__BQnyjFnq__"